<div class="gt-routes-list-containerss gt-grid-left-top-corner-flat">
  <div class="gt-list-outer-containers">
    <dx-data-grid #personGrid *ngIf="contactTags != null && persons != null" id="gridContainer" [dataSource]="persons"
      class="gt-data-grid-style gt-grid-left-top-corner-round contacts-persons-list" [allowColumnReordering]="true"
      [rowAlternationEnabled]="true" (onRowClick)="showDetails($event)" height="100%"
      (onCellPrepared)="onCellPrepared($event)" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
      [columnAutoWidth]="false" [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }"
      [width]="'100%'" [hoverStateEnabled]="true">
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-scrolling mode="standard"></dxo-scrolling>
      <dxo-paging [enabled]="false"></dxo-paging>

      <dxo-toolbar>
        <dxi-item width="50%" location="before">
          <dx-text-box
            [(value)]="searchTerm"
            mode="search"
            valueChangeEvent="keyup"
            width="100%"
            class="custom-search-panel"
            (onValueChanged)="personGrid.instance.searchByText($event.value)"
            i18n-placeholder="@@personsSearch"
            placeholder="Search persons..."
          ></dx-text-box>
        </dxi-item>
        <dxi-item width="50%">
          <div class="gt-flex-dir-row">
            <app-gpd-button i18n-text="@@newContact" text="New Contact"
              icon="add" (onClick)="goToAddPerson()"></app-gpd-button>
          </div>
        </dxi-item>
        <!--      <dxi-item>
              <dx-text-box [value]="searchValue" [showClearButton]="true" i18n-placeholder="@@search ..."
                    placeholder="Search ..." valueChangeEvent="keyup" (onValueChanged)="searchValueChanged($event)">
                </dx-text-box>
            </dxi-item> -->
      </dxo-toolbar>
      <dxi-column dataField="firstname" i18n-caption="@@firstname" caption="Firstname" [allowFiltering]="false"
        [allowSearch]="true"></dxi-column>
      <dxi-column dataField="lastname" i18n-caption="@@lastname" caption="Lastname" [allowFiltering]="false"
        [allowSearch]="true"></dxi-column>
      <dxi-column dataField="phoneMobile" i18n-caption="@@phoneMobile" caption="Phone (Mobile)" [allowFiltering]="false"
        [allowSearch]="true"></dxi-column>
      <dxi-column dataField="email" i18n-caption="@@email" caption="Email" [allowFiltering]="false"
        [allowSearch]="true">
      </dxi-column>

      <dxi-column dataField="fullAddress" i18n-caption="@@address" caption="Address" cellTemplate="adresseTemplate"
        alignment="left" [allowFiltering]="false" [allowSearch]="true">
        <div *dxTemplate="let item of 'adresseTemplate'">
          <div
            *ngIf="item.data.address != null && item.data.zipcode != null && item.data.city != null; else addressNotComplete"
            [innerHtml]="highlightText(item.data.address + ', ' + item.data.zipcode + ' ' + item.data.city)"></div>

          <ng-template #addressNotComplete> </ng-template>
        </div>
      </dxi-column>

      <dxi-column [allowFiltering]="true" [allowHeaderFiltering]="true" dataField="tags" i18n-caption="@@tags"
        caption="Tags" cellTemplate="tagTemplate" [calculateFilterExpression]="filterTags" [allowSearch]="true">
        <dxo-lookup [dataSource]="contactTags" valueExpr="id" displayExpr="title"></dxo-lookup>
        <div *dxTemplate="let item of 'tagTemplate'">
          <div *ngIf="contactTags != null && contactTags != undefined" class="contact-tag-container">
            <gpd-pill
              *ngFor="let tag of item.data.tags"
              [text]="getTag(tag)"
              backgroundColor="var(--color-secondary)"
              color="var(--color-primary)"
            ></gpd-pill>
          </div>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>